var heading_default = {
  "fontElementMap": "_4m0D-",
  "elementSpacing": "eb9r5",
  "headerOne": "rE0FX eb9r5",
  "headerTwo": "_7B1rk eb9r5",
  "headerThree": "I6wqz eb9r5",
  "headerFour": "MPnNQ eb9r5",
  "headerFive": "NSLpp eb9r5",
  "headerSix": "q1yET eb9r5",
  "child": "q4r6p"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
